module.exports = __webpack_public_path__ + "static/media/colzones-logo-256px.5f0ba92b.png";